<template>
  <v-app id="inspire">
    <v-app-bar app >

      <v-btn
            plain
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            @click="$emit('close')"
            large
          >
            <v-icon dark large> mdi-close-box </v-icon>
          </v-btn>

      <v-toolbar-title class="text-h6">{{ allcnt }}台</v-toolbar-title>
      <v-spacer></v-spacer>

     <v-btn @click="showOverlay = true" color="primary">説明</v-btn>

      <v-spacer></v-spacer>

         <!-- 遮罩层 -->
     <v-overlay
     
      :value="showOverlay"
      @click="showOverlay = false"
       absolute
      style="top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999;"
      opacity="1"
    
    >
     <v-card color="white">
      <!-- 图片全屏显示 -->
      <v-img
        src="../public/main_page/sample_text.jpeg"
        class="fullscreen-image"
        contain
      ></v-img>
      </v-card>

    </v-overlay>

      
    <v-dialog v-model="dialog_report" persistent fullscreen dense>
      <v-card>
      <v-btn
              icon
              dark
              @click="dialog_report = false"
              large
            ></v-btn>

            <report v-model="list" />

      </v-card>

    </v-dialog>


      

      <v-dialog v-model="dialog_select" persistent max-width="1000px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn plain color="primary" dark v-bind="attrs" v-on="on" small>
            <v-icon dark large>mdi-filter-menu</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h4">セレクト</span>
          </v-card-title>
          <v-card-text>
            <v-container>
                <v-radio-group row v-model="select_gui">
                <v-radio label="協力会社名" value="1"></v-radio>

                <v-radio label="ID" value="3"></v-radio>
              </v-radio-group>

              <v-row>
                <v-col cols="6">
                  <input
                    type="checkbox"
                    :value="true"
                    v-model="list_floor_select_all"
                    v-on:click="floor_checkedAll()"
                  />
                  すべて選択

                  <template v-for="(spec, index) in list_floor">
                    <v-col
                      no-gutters="true"
                      :key="index"
                      class="ma-0 pa-0"
                      cols="12"
                    >
                      <input
                        type="checkbox"
                        :value="true"
                        v-model="list_floor[index].check"
                      />
                      {{ list_floor[index].floor }}
                    </v-col>
                  </template>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="6">
                  <input
                    type="checkbox"
                    :value="true"
                    v-model="list_company_select_all"
                    v-on:click="company_checkedAll()"
                  />
                  すべて選択
                  <template v-for="(spec, index) in list_company">
                    <v-col
                      no-gutters="true"
                      :key="index"
                      class="ma-0 pa-0"
                      cols="12"
                    >
                      <input
                        type="checkbox"
                        cols="12"
                        class="checkBoxTest"
                        :value="true"
                        v-model="list_company[index].check"
                      />
                      {{ list_company[index].company }}
                    </v-col>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog_select = false">
              閉じる
            </v-btn>
            <v-btn color="blue darken-1" text @click="onSelect_list()">
              適用
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-app-bar>

       


    <v-snackbar
      v-model="snackbar"
      bottom
      color="deep-purple accent-4"
      timeout="2000"
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-dialog v-model="dialog_message" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-col class="ma-0 pa-0">
            <v-row class="ma-0 pa-0">
              
                {{ dialog_message_data.car_number }}


              

              
              <v-spacer></v-spacer>
              <!--<v-switch label="故障" v-model="broke" @change="judge_broke()"></v-switch>-->

              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog_message = false">
                閉じる
              </v-btn>
            </v-row>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container class="ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0"> </v-col>
              <v-row class="ma-0 pa-0">
                <p class="text-h5">協力会社名:</p>

                <v-select
                  v-model="dialog_message_data.company"
                  :items="list_base_company"
                  dense
                ></v-select>
              </v-row>

              <v-row class="ma-0 pa-0">
                <p class="text-h5">名前:</p>

                <v-text-field
                  label="使用者名を入力してください"
                  v-model="dialog_message_data.name"
                  class="ma-0 pa-0"
                ></v-text-field>
              </v-row>

              <v-row class="ma-0 pa-0">

              <v-radio-group row  v-model="dialog_message_data.car_type" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0">
                  <p class="text-h5">作業⾞タイプ:</p>
                  

                <v-row class="ma-0 pa-0">
                  <v-radio label="ホイール式" value="wheel"></v-radio>

                <v-radio label="クローラ式" value="crawler"></v-radio>

                </v-row>
                
                
                <v-row class="ma-0 pa-0"> 
                  <v-radio label="⾼所作業台" value="platform"></v-radio>

                <v-radio label="昇降式移動⾜場" value="scaffolding"></v-radio>
                  
                </v-row>
                </v-col>
               
                
              </v-radio-group>
              </v-row>

              <v-radio-group row v-model="dialog_message_data.add_deck" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0">
                
                <p class="text-h5">スライド式拡張デッキ:</p>
                <v-row class="ma-0 pa-0">
                  <v-radio label="無し" value="no"></v-radio>

                <v-radio label="あり" value="yes"></v-radio>

                </v-row>
                </v-col>
              </v-radio-group>





              <v-row class="ma-0 pa-0">
                <p class="text-h5">作業車高さ:</p>

                <v-select
                  v-model="dialog_message_data.car_comment"
                  :items="list_base_car_pra"
                  dense
                ></v-select>
              </v-row>

              <v-row class="ma-0 pa-0">
                <p class="text-h5">ﾚﾝﾀﾙ会社:</p>

                <v-select
                  v-model="dialog_message_data.user_rent_company"
                  :items="rent_company_list_true"
                  dense
                ></v-select>
              </v-row>

              <v-row class="ma-0 pa-0">
                <p class="text-h5">ｽﾃｰﾀｽ:</p>

                <v-text-field
                  :disabled="!states_enable"
                  :label="get_states_label()"
                  v-model="dialog_message_data.comment"
                  class="ma-0 pa-0"
                ></v-text-field>
              </v-row>

              <v-col>
                <v-sheet>
                  <v-calendar
                    ref="calendar"
                    :now="today"
                    :value="today1"
                    :events="events"
                    color="primary"
                    type="4day"
                    interval-height="25
                    "
                    interval-width="0"
                    interval-count="24"
                    :interval-format="intervalFormat"
                    :interval-style="intervalStyle"
                  >
                    <template v-slot:day-body="{}">
                      <div class="v-current-time"></div>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-col>

              <!--<canvas id="test12" ></canvas>-->
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          

          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_message = false">
            閉じる
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="change_name_comment()"
          >
            適用
          </v-btn>
        </v-card-actions>
      </v-card>

      
    </v-dialog>

    <v-main style="height: 100%;" >
      <van-pull-refresh
              v-model="refreshing"
              loosing-text="Refresh success"
              pulling-text="Refresh success"
              success-text="Refresh success"
              :disabled="refDisabled"
              @refresh="reload_now()"
            >
          

            
      <nobr v-if="simple_mode == true">
<v-container fluid>
        <v-row>
         

          
          <template v-for="(spec, index) in list" >
            <v-col no-gutters="true" :key="index" class="ma" cols="12">
              <v-card
                :color="getfloorcardcolor(index)"
                no-gutters="true"
                class="mx-auto"
                outlined
                elevation="0"
                cols="12"
              >
                <v-card-title class="black--text mt"
                  ><span class="text-h4"
                    >{{ spec.floor }}F :{{ spec.data.length }}台</span
                  ></v-card-title
                >
                <v-row>
                  <v-col
                    no-gutters="true"
                    v-for="(para, i) in spec.data"
                    :key="`${index}${i}`"
                    cols="6"
                    class="mt"
                    color="blue"
                    xs="6"
                    sm="3"
                    md="2"
                    lg="2"
                    xl="1"
                  >



                      <v-card
                        :color="
                          getcarcardcolor(
                            para.three_days_ago,
                            para.two_days_ago,
                            para.one_days_ago,
                            para.today,
                            para.cal_flag,
                            para.servertime
                          )
                        "
                        no-gutters="true"
                        class="mx-auto"
                        max-width="180"
                        max-hight="120"
                        elevation="24"
                        @click="
                          show_car_message(para) /*,draw(para.beacon_mac)*/
                        "
                      >

                       <v-banner
                            :height="get_rent_size(para.user_rent_company)"
                            :color="get_rent_color(para.user_rent_company)"
                            max-width="180"
                            
                            single-line
                            class="ma-0 pa-0"
                            :value="
                              get_rent_size(para.user_rent_company) == 0
                                ? false
                                : true
                            "
                          ></v-banner>

                      <p class="ma-0 pa-0">
                          {{ para.car_number
                          }}<b>({{ get_select_gui(para) }})</b>
                        </p>
                        

                        <div></div>

                        <v-icon  :color="gettoday(para.today)">{{
                          get_icon_0_9(para.today, true)
                        }}</v-icon>
                        <v-icon  :color="gettoday(para.one_days_ago)">{{
                          get_icon_0_9(para.one_days_ago, false)
                        }}</v-icon>
                        <v-icon  :color="gettoday(para.two_days_ago)">{{
                          get_icon_0_9(para.two_days_ago, false)
                        }}</v-icon>
                        <v-icon  :color="gettoday(para.three_days_ago)">{{
                          get_icon_0_9(para.three_days_ago, false)
                        }}</v-icon>

                        <nobr
                          v-if="getcomment(para.comment) == 1"
                          class="overline mb-6"
                        >
                          <v-icon  color="red darken-2"
                            >mdi-message-alert</v-icon
                          >
                        </nobr>
                        <nobr
                          v-else-if="getcomment(para.comment) == 0"
                          class="overline mb-6"
                        >
                          <v-icon  color="green darken-2"
                            >mdi-message-alert</v-icon
                          >
                        </nobr>

                        <nobr>
                          <v-icon  color="green darken-2">{{
                            get_signal_level(para.lqi)
                          }}</v-icon>
                        </nobr>

                        
                        <nobr>
                          
                          <!--<v-icon class="custom-icon" x-large  :color="get_rent_color(para.user_rent_company)">{{
                            get_rent_icon(para.car_type,para.add_deck)
                          }}</v-icon>-->
                         
                        </nobr>
                        


                        <div></div>
                        <nobr>{{ myTimeToLocal(para.servertime) }}</nobr>

                        <v-icon small :color="getbattery_color(para.battery)">{{
                          getbattery_icon(para.battery)
                        }}</v-icon>

                         <v-badge
                          color="indigo"
                          size="20"
                          :content="para.car_comment"
                          
                          :value="set_badges(para.car_comment)"
                        >
                        </v-badge>

                        
                      </v-card>

                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </template>
        </v-row>

       

      </v-container>
      </nobr>

</van-pull-refresh>
      
    </v-main>
  </v-app>
</template>

<style>

.fullscreen-image {
  width: 100vw;
  height: 100vh;
  object-fit: cover; /* 确保图片覆盖整个屏幕 */
}

.custom-icon {
  background-color: white; /* 设置背景色 */
  border-radius: 10%; /* 可选的圆角 */
}

.checkBoxTest {
  zoom: 100%;
}

.full-width-image {
  position: relative;
  object-fit: cover; 
  width: 100%; 
  height: 100%; 
}
.custom-container {
  overflow: auto;
  background-image: url("https://quickerz-source.s3.ap-northeast-1.amazonaws.com/image/back_build1.jpg"); 
  background-size: cover;
  background-repeat: repeat;
  width: 100%; 
  height: 100vh; 
}

.custom-container1 {
  background: transparent !important;
   position: relative; 
  z-index: 0; 
}



.v-main {
  background-size: cover;
  background-attachment: fixed;
  height: 100vh;
}



.no-margin-lines {
  margin: 0;
  line-height: 1;
}

.card-in-image {
  position: absolute;
  top: 5%; 
  left: 8%; 
  transform: translateX(0%); 
  width: 68%; 
  margin: 0;
  line-height: 2;
}

.img-in-image {
  position: absolute;
  bottom: 15%; 
  left: 20%; 
  transform: translateX(0%); 
  width: 50%; 
  margin: 0;
  line-height: 2;
}

.badge_signal_level{
    position: absolute;
  top: 5%; 
  left: 90%; 
  transform: translateX(0%); 
  width: 10%; 
  margin: 0;

}



.badge-in-container {
  position: absolute;
  bottom: 5%; 
  left: 33%; 
  z-index: 2;
  transform: translateX(0%);
}


</style>





<script>
import "../public/svg/front/style.css";

//import scrollText from "@/components/scrollText";

//import report from "@/components/report.vue";


export default {
  //data: () => ({ drawer: null }),

  
  
  data() {
    return {
      drawer: false,
      list_all: [], //all data list for area
      list: [], //selected list by list all
      list_company: [], //all company list for area
      list_company_select_all: true, //company select all
      list_floor: [], //all floor list for area
      list_floor_select_all: true, //floor select all
      dialog_login: false, //dialog login enable or not
      dialog_manager: false, //dialog manager enable or not
      dialog_select: false, //dialog select enable or not

      allcnt: 0, //number of car for list
      QRString: "", //qrcode data
      dialog_message: false, //dialog message enable or not
      dialog_message_data: [], //dialog message data

      dialog_area_data: [], //dialog area data

      dialog_report:false,

      comment_list: [],

      area_id: "", //area id input
      area_pass: "", //area password input
      name: "", //login name
      states_enable: false, //login by login name
      select_gui: "1",
      refDisabled:true,

      showOverlay:false,




      show_car_list: false, //show car_list gui
      show_company_list: false, //show company_list gui
      show_car_pra_list: false, //show car_pra_list gui
      show_user_rent_company_list: false, //show user_rent_company_list gui

      area_login_ok: false, //area login succeed
      password_remain: true, //password remain for 30 days
      simple_mode:true,
      color_list: [
        //color by company (not use)
        "#FF6D00",
        "#F48FB1",
        "#FFEB3B",
        "#BA68C8",
        "#B8860B",
        "#FFF0F5",
        "#E6E6FA",
        "#F5FFFA",
      ],
      hour_time: [], //time when get (6) times floor message from server
      hour_floor: [], //floor when get (6) times floor message from server

      remain_sigfoxid: [], //sigfoxid selected from server
      now_sigfoxid: [], //sigfoxid selected from server

      remain_car_number: [], //car_number selected from server
      now_car_number: [], //car_number selected from server

      items_add_sigfox: [], //show message if car  add success

      list_base_sigfoxid: [], //sigfox list message from server
      add_base_sigfoxid: "", //sigfox id by scan QRcode

      list_base_car_number: [], //car list message from server
      add_base_car: "", //car name selected

      list_base_company: [], //company list message from server
      company_copy: "", //company by selected or default

      

      list_beacon_mac: [],

      list_base_car_pra: [],

      list_floor_area: [],
      base_floor: 0,
      static_base_floor: 0,
      base_hight_offset: 0,
      static_base_hight_offset: 0,
      cal_on: false,
      rent_company_list: [],
      rent_company_list_true: [],

      /** */
      mobile_check: false,
      refreshing: false,
      finished: false,
      loading: false,

      auto_refresh:false,
      auto_refresh_loop_id:null,


      //randomLoopCount_floor :20,

      //*********************220606 */
      now_cal_floor: 0,
      now_cal_hight: 0,
      cal_alert_message: false,
      isActive: false,

       attrs: {}, // 用于传递属性
    on: {}, // 用于绑定事件


      base_number0: "",
      base_number1: "",
      base_number2: "",
      base_number: "",
      base_nb: 0,
      static_base_number: "",

      snackbar: false,
      snackbar_text: `操作成功`,
      judg_cnt: 3,
      judg_cnt_list: [1, 2, 3, 4, 5, 6, 7, 8, 9],

      car_comment_now: "",
      car_comment_list: [
        "",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ],

      today: "2022-02-5", //カレンダーstoptime
      today1: "2022-02-7", //カレンダーstarttime
      events: [
        //カレンダーeventパラメータ
      ],

      /*********220822 */

      floor_base_data: [],
      isupload: false,

      change_car_number_new_number: "",

      user_floor:1,

      broke:false,

      e2: 1,

      e3: 1,
      e4: 1,

      dialog_set_area: false,

      area_par_new: {
        country_area: "",
        floor_min_count: 0,
        floor_count: 20,
        real_name: "",
        id: "",
        user_pass: "",
        manager_pass: "",
        Elevation: 0.5,
        floor_data: [],
        floor_dev_data: [],
      },

      colorOptions_base: ['blue', 'red', 'green', 'orange', 'pink', 'yellow'] ,
      colorOptions_useable:[],
      colorOptions_inuse:[],

      hightRule: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 15) ||
          "高度入力エラー 0m ～ 15m",
      ],
      floorRule: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= -6 && v <= 99) ||
          "フロア入力エラー -6F ～ 99F",
      ],
      ElevationRule: [
        (v) => (!isNaN(parseFloat(v)) && v >=0) || "海抜入力エラー　海抜＞=0ｍ ",
      ],

      area_list: {
        car_list: [""],
        company_list: [""],
      },

      intervalFormat() {
        const shortHourOptions = {
          timeZone: "UTC",
          hour12: true,
          hour: "numeric",
        };

        return shortHourOptions;
      },

      intervalStyle() {
        return {
          //backgroundColor: 'rgba(0,0,0,0.4)'
        };
      },

    };
  },

  computed: {
  },

  watch: {
    
  },

  methods: {

    divScroll(){
      let toTop = this.$refs.Box.scrollTop;
      //console.log('距离顶部'+toTop);
      if(toTop==0){
        this.refDisabled=false
      }
      else{
        this.refDisabled=true;
      }

    },

    get_rent_icon(car_type,add_deck){
      
       if(add_deck == "no"){
        if(car_type == "crawler"){
          return 'icon-Crawler_normal';
        }else if(car_type == "wheel"){
          return 'icon-wheel_normal';
        }else{
          return 'icon-Crawler_normal';
        }

      }else{

        if(car_type == "crawler"){
          return 'icon-Crawler_add';
        }else if(car_type == "wheel"){
          return 'icon-wheel_add';
        }else{
          return 'icon-Crawler_add';
        }

      }


    },

    

    generateRandomTime() {
      const now = new Date();
      const randomMinutes = Math.floor(Math.random() * 200); // 随机生成 0 到 29 分钟前的时间
      now.setMinutes(now.getMinutes() - randomMinutes);
      // 直接加上 9 小时
      now.setHours(now.getHours() + 9);
      return now.toISOString(); // 返回加上 9 小时的 ISO 格式字符串
    },

    getRandomCarComment() {
  const companies = [
  "3.8m",
  "4.5m",
  "6.0m",
];
this.list_base_car_pra = companies;
  const randomIndex = Math.floor(Math.random() * companies.length);
  return companies[randomIndex];
},

getRandomName() {
  const names = [
  "佐藤 太郎",
  "鈴木 花子",
  "高橋 健一",
  "田中 美咲",
  "渡辺 裕樹",
  "伊藤 恵子",
  "山本 直樹",
  "中村 由美",
  "小林 亮太",
  "加藤 真由美",
  "吉田 大輔",
  "山田 理恵",
  "佐々木 修",
  "松本 絵里",
  "井上 翔太",
  "木村 あかり",
  "林 和也",
  "斎藤 美沙",
  "清水 一郎",
  "池田 千尋"
];
this.list_base_car_pra = names;
  const randomIndex = Math.floor(Math.random() * names.length);
  return names[randomIndex];
},

    

// 生成随机的公司名称
getRandomCompany() {
  const companies = [
  "南海建設",
  "東京土木",
  "西日本工業",
  "九州設計",
  "近畿建工",
  "中部都市開発",
  "北陸建設",
  "神奈川工務店",
  "広島建築",
  "四国建設設計"
];
this.list_base_company = companies;
  const randomIndex = Math.floor(Math.random() * companies.length);
  return companies[randomIndex];
},
getRandomRentCompany() {
  const companies = [
  "西尾レントオール",
  "アクティオ",
  "朝日機材",
];
this.rent_company_list_true = companies;
  const randomIndex = Math.floor(Math.random() * companies.length);
  return companies[randomIndex];
},
    generateRandomEntry(floor) {
      
      return {
        sigfoxid: `22F${Math.random().toString(16).substr(2, 6).toUpperCase()}`, // 随机生成 sigfoxid
        pressure: Math.floor(Math.random() * (102000 - 100000) + 100000), // 随机生成压力
        basepressure: Math.floor(Math.random() * (102000 - 100000) + 100000),
        hight: (Math.random() * 100).toFixed(2), // 随机生成高度
        floor: floor,
        diff_hight: (Math.random() * 2).toFixed(2), // 随机生成高度差异
        sigfoxtime: this.generateRandomTime(),
        servertime: this.generateRandomTime(),
        move: Math.random() > 0.5 ? 1 : 0, // 随机生成 move 值 (0 或 1)
        battery: 1, 
        area: Math.floor(Math.random() * 200), // 随机生成 area 值
        area_name: "touroku0507",
        company: this.getRandomCompany(),
        car_number: String(Math.floor(Math.random() * 100)).padStart(3, '0'), // 随机生成三位数车号
        nine_days_ago: Math.floor(Math.random() * 8),
        eight_days_ago: Math.floor(Math.random() * 8),
        seven_days_ago: Math.floor(Math.random() * 8),
        six_days_ago: Math.floor(Math.random() * 8),
        five_days_ago: Math.floor(Math.random() * 8),
        four_days_ago: Math.floor(Math.random() * 8),
        three_days_ago: Math.floor(Math.random() * 4),
        two_days_ago: Math.floor(Math.random() * 5),
        one_days_ago: Math.floor(Math.random() * 9),
        today: Math.floor(Math.random() * 5),
        name: this.getRandomName(),
        comment: "",
        day_base: 0,
        comment_name: "",
        comment_time: "0000-00-00 00:00:00.0",
        cal_flag: 1,
        lat: (Math.random() * (35.7 - 35.6) + 35.6).toFixed(6), // 随机生成经纬度
        lng: (Math.random() * (139.6 - 139.5) + 139.5).toFixed(6),
        lqi: ["Limit", "Good", "Average"][Math.floor(Math.random() * 3)], // 随机生成 lqi 值
        voltage: Math.floor(Math.random() * 15) + 10, // 随机生成电压值
        ver: "3",
        beacon_mac: "000000000000",
        rent_company: this.getRandomRentCompany(),
        user_rent_company: this.getRandomRentCompany(),
        variance: (Math.random() * 50000).toFixed(1), // 随机生成 variance 值
        sigfox_msg_period: Math.floor(Math.random() * 6) + 1,
        user_alarm: 0,
        car_comment:this.getRandomCarComment(),
        car_type: "wheel",
        add_deck: "no",
        broke: "no",
      };
    },
    generateRandomData() {
      const dataByFloor = {};

       //const options_floor = [10,20,50];

// 随机选择一个选项
    //this.randomLoopCount_floor = options_floor[Math.floor(Math.random() * options_floor.length)];

      // 初始化 floor 数据
      for (let i = 1; i <= 40; i++) {
        dataByFloor[i] = {
          floor: i,
          data: [],
        };
      }

      //const options = [50, 100, 200, 400];

// 随机选择一个选项
//const randomLoopCount = options[Math.floor(Math.random() * options.length)];

      // 生成 200 个随机数据
      for (let i = 0; i < 300; i++) {
        const floor = Math.floor(Math.random() * 40) + 1; // 随机生成 floor 值，范围为 1 到 20
        const entry = this.generateRandomEntry(floor);
        dataByFloor[floor].data.push(entry); // 将生成的 entry 添加到相应 floor 的 data 数组中
      }

      // 将 dataByFloor 转换为数组格式
      return Object.values(dataByFloor);
    },

    getData() {
      if (this.password_remain == true) {
        this.$cookies.set(
          "quickerz_manager",
          this.name + "," + this.area_id + "," + this.area_pass,
          "360d"
        );
      } else {
        this.$cookies.remove("quickerz_manager");
      }
      this.list_all = [];
      this.list = [];

      setTimeout(() => {
      
          this.list_all = this.generateRandomData();
          this.list_all.sort(function (b, a) {
            return a.floor - b.floor;
          });
          var obj_company = {};
          var obj_floor = {};
          this.list_floor = [];
          this.list_company = [];

          this.comment_list = [];
          this.now_sigfoxid = [];
          this.now_car_number = [];
          var cnt_sigfoxid = 0;

          for (var i = 0, len_i = this.list_all.length; i < len_i; i++) {
            var s = this.list_all[i].floor;
            if (obj_floor[s]) continue;
            else {
              obj_floor[s] = s;
              this.list_floor.push({ floor: s, check: true });
            }
            for (
              var j = 0, len_j = this.list_all[i].data.length;
              j < len_j;
              j++
            ) {
              this.now_sigfoxid[cnt_sigfoxid] =
                this.list_all[i].data[j].sigfoxid;
              this.now_car_number[cnt_sigfoxid] =
                this.list_all[i].data[j].car_number;

              cnt_sigfoxid++;
              var comment = this.list_all[i].data[j].comment;
              console.log(this.list_all[i].data[j].sigfoxid);
              console.log(this.list_all[i].data[j].servertime);
              if (comment != "") {
                this.comment_list.push({
                  car: this.list_all[i].data[j].car_number,
                  comment: comment,
                  comment_time: this.myTimeToLocal(
                    this.list_all[i].data[j].comment_time
                  ),
                  comment_name: this.list_all[i].data[j].comment_name,
                  company: this.list_all[i].data[j].company,
                });
                //console.log(this.comment_list);
              }

              var c = this.list_all[i].data[j].company;
              if (obj_company[c]) continue;
              else {
                obj_company[c] = c;
                this.list_company.push({
                  company: c,
                  check: true,
                  color: this.color_list[j % 8],
                }); //结果放入新数组中
              }
            }
          }

          this.list_floor_select_all = true;
          this.list_company_select_all = true;
          var objString = JSON.stringify(this.list_all);
          this.list = JSON.parse(objString);
          //console.log(this.list);
          this.allcnt = 0;
          for (var num = 0; num < this.list.length; num++) {
            this.allcnt += this.list[num].data.length;
          }
          this.dialog_login = false;

                              if(this.getfloorcookies() == "null"){
            this.list_floor_select_all=true;
          }


      },500);

       


        
    },

    sleepn(n) {
      var start = new Date().getTime();

      while (new Date().getTime() - start < n) {
        continue;
      }
    },

    importCsv() {
      this.area_list.car_list = [];
      this.area_list.company_list = [];
      console.log("test");

      let selectedFile = null;
      selectedFile = this.$refs.refFile.files[0];
      //console.log(this.$refs.refFile)
      if (selectedFile === undefined) {
        //console.log("test0")
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onload = (evt) => {
        this.$papa.parse(selectedFile, {
          encoding: "SHIFT_JIS",
          complete: (res) => {
            let data = res.data;
            if (data[data.length - 1] == "") {
              data.pop();
            }

                        this.area_list.car_list = [data.length];
            this.area_list.company_list = [data.length];


            for (var a = 0; a < data.length - 1; a++) {
              //console.log(data[a + 1][1]);
              if (data[a + 1][0] !== "") {
                this.area_list.car_list[a] = data[a + 1][0];
                //console.log(this.area_list.car_list);
              }

              if (data[a + 1][1] !== "") {
                this.area_list.company_list[a] = data[a + 1][1];
                //console.log(this.area_list.company_list);
              }
            }

            //console.log(this.area_list.sigfox_list);
            //console.log(this.area_list.car_list);
            //console.log(this.area_list.company_list);
            if (this.e3 == 1) {
              this.e3 = 2;
            } else {
              this.e3 = 1;
            }

            this.isupload = true;
          },
        });
        console.log(evt);
      };
    },

    

    

    change_name_comment() {
      
    },

    

     setfloorcookies(kill,cookie){
      if(kill == true){
        this.$cookies.remove("quickerz_floor_cookies");
      }else{
        this.$cookies.set(
          "quickerz_floor_cookies",
          cookie,
          "30d"
          );
      }

    },



    getfloorcookies(){
      try {
        var cookie = this.$cookies.get("quickerz_floor_cookies");
        var floor_c = cookie.split(",");

         for (var k = 0; k < this.list_floor.length; k++) {

          for(var o=0;o<floor_c.length;o++){
            if(floor_c[o] == this.list_floor[k].floor){
              console.log(floor_c[o]+":"+this.list_floor[k].floor+"true")
              this.list_floor[k].check = true;
              break
            }else if(o == floor_c.length -1){
              console.log(floor_c[o]+":"+this.list_floor[k].floor+"false")
              this.list_floor[k].check = false;
            }
          }

          // if(floor_c.includes(this.list_floor[k].floor)){
          //   this.list_floor[k].check = true;
          // }else{
          //   this.list_floor[k].check = false;
          // }
        }



        this.onSelect_list();



        return cookie;
      } catch (err) {
        return "null";
      }

    },


    get_calendar_hight() {
      return 25;
    },

     downloadFile(data) {
      const fileData = JSON.stringify(data, null, 2); // 格式化 JSON 数据
      const blob = new Blob([fileData], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

  generatehourData(message) {
  const n = 120; // 总共生成 120 个数据
  const jsonData = {
    datat: [],
    dataf: [],
    datam: [],
  };

  // 初始化 floor 数据
  let currentFloor = Math.floor(Math.random() * 20) + 1;

  // 获取当前时间
  let now = new Date();
  now.setHours(now.getHours() + 9);  // 将时间加上9小时以适应时区差异

  // 定义每一天的 move 数量
  const days = ['three_days_ago', 'two_days_ago', 'one_days_ago', 'today'];
  const movesPerDay = message;  // 从 message 中获取每一天的 move 数量

  // 创建函数来生成特定时间段的数据
  function getHourTime(startTime, hoursBefore) {
    return new Date(startTime.getTime() - hoursBefore * 60 * 60 * 1000);
  }

  // 按照每一天的 move 数量来生成数据
  let totalHoursGenerated = 0;
  for (let dayIdx = 0; dayIdx < days.length; dayIdx++) {
    const moveCountForDay = movesPerDay[days[dayIdx]]; // 当前天的 move 数量
    let movesGeneratedForDay = 0;

    for (let i = 0; i < 24 && totalHoursGenerated < n; i++) {
      // 生成倒序且间隔为 1 小时的时间
      const newTime = getHourTime(now, totalHoursGenerated);
      jsonData.datat.push(newTime.toISOString());

      // 判断是否生成 move，按 message 中的数量分配 move
      let isMove = 0;
      if (movesGeneratedForDay < moveCountForDay) {
        isMove = 1;
        movesGeneratedForDay++;
      }

      // 处理 floor 的变动逻辑，只有在 move 为 1 时才有可能变动楼层
      if (isMove ) {
        // floor 变动
        currentFloor = Math.floor(Math.random() * 20) + 1;
        jsonData.datam.push(1); // floor 变动时，datam 为 1
      } else {
        jsonData.datam.push(0); // floor 不变动时，datam 为 0
      }

      // 将当前 floor 值添加到 dataf 中
      jsonData.dataf.push(currentFloor);

      totalHoursGenerated++; // 增加总生成小时数
    }
  }

  return jsonData;
},

    get_hour_data(message) {
       
      var now = this.$moment(new Date()).format("YYYY-MM-DD");
      var nowb3 = this.$moment(new Date())
        .subtract(3, "days")
        .format("YYYY-MM-DD");
      this.today = now;
      this.today1 = nowb3;
      let response={body:''};
      response.body = this.generatehourData(message);
      console.log(response.body);
      setTimeout(() => {

          this.hour_floor = response.body.dataf;
          this.events = [];
          this.$refs.calendar.scrollToTime("08:30");
          for (var i = 0; i < response.body.datat.length; i++) {
            this.hour_time[i] = this.myTimeToLocal(response.body.datat[i]);
            if (response.body.datam[i] == 0) {
              if (i != 0) {
                if (
                  new Date(response.body.datat[i]).getTime() -
                    new Date(response.body.datat[i - 1]).getTime() <
                  3600 * 1000
                ) {
                  this.events.push({
                    name: response.body.dataf[i] + "   F",
                    end: this.timeg(response.body.datat[i-1]),
                    start: this.timeg(response.body.datat[i ]),
                    color: "green",
                    timed: true,
                    height: 0,
                  });
                } else {
                  this.events.push({
                    name: response.body.dataf[i] + "   F",
                    end: this.timeg(response.body.datat[i]),
                    start: this.times(response.body.datat[i]),
                    color: "green",
                    timed: true,
                    height: 0,
                  });
                }
              } else {
                this.events.push({
                  name: response.body.dataf[i] + "   F",
                  end: this.timeg(response.body.datat[i]),
                  start: this.times(response.body.datat[i]),
                  color: "green",
                  timed: true,
                  height: 0,
                });
              }
            } else {
              if (i != 0) {
                if (
                  new Date(response.body.datat[i]).getTime() -
                    new Date(response.body.datat[i - 1]).getTime() <
                  3600 * 1000
                ) {
                  this.events.push({
                    name: response.body.dataf[i] + "   F",
                    end: this.timeg(response.body.datat[i-1]),
                    start: this.timeg(response.body.datat[i]),
                    timed: true,
                    color: "red",
                    height: 0,
                  });
                } else {
                  this.events.push({
                    name: response.body.dataf[i] + "   F",
                    end: this.timeg(response.body.datat[i]),
                    start: this.times(response.body.datat[i]),
                    timed: true,
                    color: "red",
                    height: 0,
                  });
                }
              } else {
                this.events.push({
                  name: response.body.dataf[i] + "   F",
                  end: this.timeg(response.body.datat[i]),
                  start: this.times(response.body.datat[i]),
                  timed: true,
                  color: "red",
                  height: 0,
                });
              }
            }
          }
         }, 500); 
    },

    get_states_label() {
      if (this.name == "") {
        this.states_enable = false;
        return "システム登録にて登録名を入力してください";
      } else {
        this.states_enable = true;
        return "使用期間等コメントを入力してください";
      }
    },
    onSelect_list() {
      var objString = JSON.stringify(this.list_all);
      this.list = JSON.parse(objString);
      var equal_flag = false;

            var cookie_f = "";
      var cnt_c_f = 0; 
      for (var f = 0; f < this.list_floor.length; f++) {
        if((f==0 || f== this.list_floor.length-1) && this.list_floor[f].check == true){
          cookie_f = cookie_f + this.list_floor[f].floor+",";
          cnt_c_f = cnt_c_f + 1;
        }else if(this.list_floor[f].check == true){
          cookie_f = cookie_f + this.list_floor[f].floor + ",";
          cnt_c_f = cnt_c_f + 1;
        }
       

      }

      if(cnt_c_f == this.list_floor.length){
        this.setfloorcookies(true,"");
      }else{
        this.setfloorcookies(false,cookie_f);
      }



      for (var i = 0; i < this.list.length; i++) {
        for (var j = 0; j < this.list[i].data.length; j++) {
          for (var g = 0; g < this.list_company.length; g++) {
            if (equal_flag == true) {
              g = 0;
              equal_flag = false;
            }

            try {
              if (
                this.list[i].data[j].company == this.list_company[g].company &&
                (this.list_company[g].check == false ||
                  this.list_company[g].check == null)
              ) {
                this.list[i].data.splice(j, 1);
                j = 0;
                i = 0;
                g = 0;
                equal_flag = true;
                console.log("delete");
              }
            } catch (e) {
              console.log("delete");
            }
          }
        }

        if (this.list[i].data.length == 0) {
          this.list.splice(i, 1);
          i = 0;
        }

        for (var k = 0; k < this.list_floor.length; k++) {
          //console.log(k+":"+this.list_floor[k].check);
          if (
            this.list[i].floor == this.list_floor[k].floor &&
            this.list_floor[k].check == false
          ) {
            this.list.splice(i, 1);
            i = 0;
          }
        }
      }
    },
    onDecode(decodedString) {
      //<qrcode-stream @decode="onDecode"></qrcode-stream>
      //console.log(decodedString);
      try {
        var a = decodedString.split(",");
        this.QRString = a[1];
        //console.log(this.QRString.length);

        if (this.QRString.substring(0, 1) == "0") {
          this.QRString = this.QRString.substring(1, 8);
        }

        //console.log(this.remain_sigfoxid.includes(this.QRString));

        if (this.remain_sigfoxid.includes(this.QRString)) {
          this.add_base_sigfoxid = this.QRString;
          console.log(this.add_base_sigfoxid);
        }
      } catch (e) {
        this.QRString = "error";
      }
      //this.QRString = decodedString;
      // ...
    },
    getdays(a, b, c, d) {
      var data = (a << 3) + (b << 2) + (c << 1) + d;
      return data;
    },
    gettoday(a) {
      if (a >= this.judg_cnt) {
        return "red darken-2";
      } else {
        return "green darken-2";
      }
    },
    //220428
    get_signal_level(level) {
      //console.log(level);
      if (level == "Excellent") {
        return "mdi-signal-cellular-" + "3";
      } else if (level == "Good") {
        return "mdi-signal-cellular-" + "2";
      } else if (level == "Average") {
        return "mdi-signal-cellular-" + "1";
      } else {
        return "mdi-signal-cellular-" + "outline";
      }
    },

    
    get_icon_0_9(a, today) {
      if (a > 9) {
        if (today == true) {
          return "mdi-numeric-" + 9 + "-box-multiple";
        } else {
          return "mdi-numeric-" + 9 + "-circle";
        }
      } else {
        if (today == true) {
          return "mdi-numeric-" + a + "-box-multiple";
        } else {
          return "mdi-numeric-" + a + "-circle";
        }
      }
    },
    getcarcardcolor(
      three_days,
      two_days,
      one_days,
      today,
      cal_flag,
      servertime
    ) {
      if (cal_flag == 0) {
        return "#7B1FA2";
      } else {
        let told = new Date(servertime).getTime();
        let tnow = new Date().getTime() + 9 * 3600000;
        //console.log(told);
        //console.log(tnow);
        if (tnow - told > 3 * 3600000) {
          return "#F06292";
        } else {
          //console.log(tnow);
          if (
            three_days < this.judg_cnt &&
            two_days < this.judg_cnt &&
            one_days < this.judg_cnt &&
            today < this.judg_cnt
          ) {
            return "#FFFF00";
          } else {
            return "#FAFAFA";
          }
        }
      }
    },

    getcomment(a) {
      var c;
      if (a === "") {
        c = 0;
      } else {
        c = 1;
      }
      return c;
    },

    getbattery_icon(b) {
      if (b == 0) {
        return "mdi-battery-charging-outline";
      } else if (b == 1) {
        return "mdi-battery";
      } else {
        return "mdi-battery";
      }
    },
    get_icon_A_Z(name) {
      return "mdi-alpha-" + name + "-box-outline";
    },

    getbattery_color(b) {
      if (b == 0) {
        return "red darken-2";
      } else if (b == 1) {
        return "green darken-2";
      } else {
        return "green darken-2";
      }
    },
    myTimeToLocal(inputTime) {
      //console.log(inputTime);
      //return inputTime;

      if(inputTime=="0000-00-00 00:00:00.0"){
        return ""
      }
      if (!inputTime && typeof inputTime !== "number") {
        return "";
      }
      var localTime = "";
      //console.log(inputTime);
      inputTime = new Date(inputTime).getTime();
      //console.log(inputTime);
      localTime = new Date(inputTime).toISOString();
      localTime = localTime.substr(0, localTime.lastIndexOf("."));
      localTime = localTime.replace("T", " ");
      localTime = localTime.replace("-", "");
      localTime = localTime.replace("-", "");
      localTime = localTime.substring(2, 14);
      return localTime;
    },
    /**時間処理メソード2*/
    times(inputTime) {
      if (!inputTime && typeof inputTime !== "number") {
        return "";
      }
      var localTime = "";
      inputTime = new Date(inputTime).getTime();
      inputTime = inputTime - 1 * 3600 * 1000;

      localTime = new Date(inputTime).toISOString();
      localTime = localTime.substr(0, localTime.lastIndexOf("."));
      localTime = localTime.replace("T", " ");
      localTime = localTime.substring(0, 18);
      //console.log(localTime);
      return localTime;
    },
    timeg(inputTime) {
      if (!inputTime && typeof inputTime !== "number") {
        return "";
      }
      var localTime = "";
      inputTime = new Date(inputTime).getTime();

      localTime = new Date(inputTime).toISOString();
      localTime = localTime.substr(0, localTime.lastIndexOf("."));
      localTime = localTime.replace("T", " ");
      localTime = localTime.substring(0, 18);
      //console.log(localTime);
      return localTime;
    },

    show_car_message(message) {
      this.dialog_message_data = message;
      this.get_hour_data(message);
      this.company_copy = this.dialog_message_data.company;
      this.get_states_label();
      this.dialog_message = true;
      if(this.dialog_message_data.broke == "yes"){
        this.broke = true;
      }else{
        this.broke = false;
      }
    },

    judge_broke(){
      if(this.broke == true){
        this.dialog_message_data.broke = "yes";
      }else{
        this.dialog_message_data.broke = "no";
      }

    },

    set_broke_on(broke){
      if(broke == "yes"){
        return 100;
      }else{
        return 1;
      }

    },

    submitForm() {
      if (this.password_remain == true) {
        this.$cookies.set(
          "quickerz_manager",
          this.name + "," + this.area_id + "," + this.area_pass,
          "30d"
        );
      } else {
        this.$cookies.remove("quickerz_manager");
      }
      if (this.getData() == 2) {
        console.log("close");
        this.dialog_login = false;
      }
    },
    getcookies() {
      try {
        var cookie = this.$cookies.get("quickerz_manager");
        var id_pass = cookie.split(",");
        if (id_pass[1] != "" && id_pass[2] != "") {
          this.name = id_pass[0];
          this.area_id = id_pass[1];
          this.area_pass = id_pass[2];
          return true;
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    getfloorcardcolor(data) {
      if (data % 2 == 0) {
        return "rgba(20, 45, 50, 0.75)";
      } else {
        return "rgba(180, 100, 50, 0.75)";
      }
    },
    floor_checkedAll() {

      //console.log(this.list_floor_select_all);
      if (this.list_floor_select_all == true) {
         this.list_floor_select_all = false;
        for (var a = 0; a < this.list_floor.length; a++) {
          this.list_floor[a].check = false;
        }
      } else if (this.list_floor_select_all == null) {
        this.list_floor_select_all = true;
        for (var b = 0; b < this.list_floor.length; b++) {
          this.list_floor[b].check = true;
        }
      } else if (this.list_floor_select_all == false) {
        this.list_floor_select_all = true;
        for (var d = 0; d < this.list_floor.length; d++) {
          this.list_floor[d].check = true;
        }
      } else {
        this.list_floor_select_all = false;
        for (var c = 0; c < this.list_floor.length; c++) {
          this.list_floor[c].check = false;
        }
      }
    },
    company_checkedAll() {
      if (this.list_company_select_all == true) {
        this.list_company_select_all =false;
        for (var a = 0; a < this.list_company.length; a++) {
          this.list_company[a].check = false;
        }
      } else if (this.list_company_select_all == null) {
        this.list_company_select_all =true;
        for (var b = 0; b < this.list_company.length; b++) {
          this.list_company[b].check = true;
        }
      } else if (this.list_company_select_all == false) {
        this.list_company_select_all =true;
        for (var d = 0; d < this.list_company.length; d++) {
          this.list_company[d].check = true;
        }
      } else {
        this.list_company_select_all =false;
        for (var c = 0; c < this.list_company.length; c++) {
          this.list_company[c].check = false;
        }
      }
    },

    exportCsvdata(data) {
      let carlist = data.car_number_list.split(",");
      let companylist = data.company_list.split(",");

      let l2 = carlist.length;
      let l3 = companylist.length;

      let l = Math.max(l2, l3);

      var data_all = "";
      var new_data = [];
      for (var a = 0; a < l; a++) {
        if (carlist[a] == null) {
          carlist[a] = "";
        }
        if (companylist[a] == null) {
          companylist[a] = "";
        }

        new_data.push({
          car_number_list: carlist[a],
          company_list: companylist[a],
        });
      }

      data_all = JSON.stringify(new_data);
      var data_json = JSON.parse(data_all);

      console.log(data_json);

      var csv = this.$papa.unparse(data_json);
      let content = new Blob(["\ufeff" + csv]);
      let urlObject = window.URL || window.webkitURL || window;
      let url = urlObject.createObjectURL(content);
      let el = document.createElement("a");
      el.href = url;
      el.download = "data.csv";
      el.click();
      urlObject.revokeObjectURL(url);
    },

    exportCsv() {
      var data_all = "";
      var new_data = [];
      let week_n = ["日","月","火","水","木","金","土"];
      let now_s = new Date();
      // let cc=week[(new Date(now_s.getTime()- 9*24*3600*1000)).getDay()] ; 
       console.log(week_n[new Date(now_s.getTime() - 9*24*3600*1000).getDay()]);
       let w9 = week_n[new Date(now_s.getTime() - 9*24*3600*1000).getDay()];
       let w8 = week_n[new Date(now_s.getTime() - 8*24*3600*1000).getDay()];
       let w7 = week_n[new Date(now_s.getTime() - 7*24*3600*1000).getDay()];
       let w6 = week_n[new Date(now_s.getTime() - 6*24*3600*1000).getDay()];
       let w5 = week_n[new Date(now_s.getTime() - 5*24*3600*1000).getDay()];
       let w4 = week_n[new Date(now_s.getTime() - 4*24*3600*1000).getDay()];
       let w3 = week_n[new Date(now_s.getTime() - 3*24*3600*1000).getDay()];
       let w2 = week_n[new Date(now_s.getTime() - 2*24*3600*1000).getDay()];
       let w1 = week_n[new Date(now_s.getTime() - 1*24*3600*1000).getDay()];
       let w0 = week_n[new Date(now_s.getTime() - 0*24*3600*1000).getDay()];

      let d9 = ""+ this.$moment(now_s- 9*24*3600*1000).format("YYMMDD")+"("+w9+")"+"";
      let d8 = ""+ this.$moment(now_s- 8*24*3600*1000).format("YYMMDD")+"("+w8+")"+"";
      let d7 = ""+ this.$moment(now_s- 7*24*3600*1000).format("YYMMDD")+"("+w7+")"+"";
      let d6 = ""+ this.$moment(now_s- 6*24*3600*1000).format("YYMMDD")+"("+w6+")"+"";
      let d5 = ""+ this.$moment(now_s- 5*24*3600*1000).format("YYMMDD")+"("+w5+")"+"";
      let d4 = ""+ this.$moment(now_s- 4*24*3600*1000).format("YYMMDD")+"("+w4+")"+"";
      let d3 = ""+ this.$moment(now_s- 3*24*3600*1000).format("YYMMDD")+"("+w3+")"+"";
      let d2 = ""+ this.$moment(now_s- 2*24*3600*1000).format("YYMMDD")+"("+w2+")"+"";
      let d1 = ""+ this.$moment(now_s- 1*24*3600*1000).format("YYMMDD")+"("+w1+")"+"";
      let d0 = "今日("+ this.$moment(now_s).format("YYMMDD")+"("+w0+")"+")";
      //console.log(d9+d8+d7+d6+d5+d4+d3+d2+d1+d0);

      for (var a = 0; a < this.list_all.length; a++) {
        for (var b = 0; b < this.list_all[a].data.length; b++) {
          this.list_all[a].data[b].rent_company = "";
          this.list_all[a].data[b].rent_sn = "";
          new_data.push({"SigfoxID":this.list_all[a].data[b].sigfoxid,
          "階":this.list_all[a].data[b].floor,
          "現場ID":this.list_all[a].data[b].area_name,
          "協力会社名":this.list_all[a].data[b].company,
          "作業車名":this.list_all[a].data[b].car_number,
          "受信日時":this.myTimeToLocal(this.list_all[a].data[b].servertime),
          [d9]:this.list_all[a].data[b].nine_days_ago,
          [d8]:this.list_all[a].data[b].eight_days_ago,
          [d7]:this.list_all[a].data[b].seven_days_ago,
          [d6]:this.list_all[a].data[b].six_days_ago,
          [d5]:this.list_all[a].data[b].five_days_ago,
          [d4]:this.list_all[a].data[b].four_days_ago,
          [d3]:this.list_all[a].data[b].three_days_ago,
          [d2]:this.list_all[a].data[b].two_days_ago,
          [d1]:this.list_all[a].data[b].one_days_ago,
          [d0]:this.list_all[a].data[b].today,
          "使用者名":this.list_all[a].data[b].name,
          "コメント":this.list_all[a].data[b].comment,
          "更新者":this.list_all[a].data[b].comment_name,
          "更新日時":this.list_all[a].data[b].comment_time,
          "作業車高さ":this.list_all[a].data[b].car_comment,


          });
        }
      }
      data_all = JSON.stringify(new_data);
      var data_json = JSON.parse(data_all);


      var csv = this.$papa.unparse(data_json );
      //定义文件内容，类型必须为Blob 否则createObjectURL会报错
      let content = new Blob(["\ufeff" + csv]);
      //生成url对象
      let urlObject = window.URL || window.webkitURL || window;
      let url = urlObject.createObjectURL(content);
      //生成<a></a>DOM元素
      let el = document.createElement("a");
      //链接赋值
      el.href = url;
      let startDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

      el.download = this.area_id+"_"+startDate+".csv";
      //必须点击否则不会下载
      el.click();
      //移除链接释放资源
      urlObject.revokeObjectURL(url);
    },

    get_company_copy(company) {
      this.company_copy = company;
      //console.log(company);
      return this.company_copy;
    },

    getlocation(lat, lng) {
      //console.log({ lat: lat, lng: lng });
      return { lat: parseFloat(lat), lng: parseFloat(lng) };
    },

    set_badges(data) {
      if (data == "") {
        return false;
      } else {
        return true;
      }
    },

    setpic(ctx, url, width, height, startX, startY, isCrossOrigin) {
      let img = new Image();
      if (isCrossOrigin) img.crossOrigin = "*";
      img.onload = function () {
        const oldWidth = this.width; //图片实际宽度
        const oldHeight = this.height; //图片实际高度
        const dw = width / oldWidth; //容器宽度 /图片实际宽度
        const dh = height / oldHeight; //容器高度/ 图片实际高度

        if (
          (oldWidth > width && oldHeight > height) ||
          (oldWidth < width && oldHeight < height)
        ) {
          //图片宽高都偏大&宽高都偏小
          if (dw > dh) {
            //偏宽
            ctx.drawImage(
              img,
              0,
              (oldHeight - height / dw) / 2,
              oldWidth,
              height / dw,
              startX,
              startY,
              width,
              height
            );
          } else {
            ctx.drawImage(
              img,
              (oldWidth - width / dh) / 2,
              0,
              width / dh,
              oldHeight,
              startX,
              startY,
              width,
              height
            );
          }
        } else {
          //拉伸图片
          if (oldWidth < width) {
            ctx.drawImage(
              img,
              0,
              (oldHeight - height / dw) / 2,
              oldWidth,
              height / dw,
              startX,
              startY,
              width,
              height
            );
          } else {
            ctx.drawImage(
              img,
              (oldWidth - width / dh) / 2,
              0,
              width / dh,
              oldHeight,
              startX,
              startY,
              width,
              height
            );
          }
        }
      };

      img.src = url;
    },

    list_clear() {
      this.area_par = {
        country_area: "",
        floor_min_count: 0,
        floor_count: 20,
        real_name: "",
        id: "",
        user_pass: "",
        manager_pass: "",
        Elevation: 0.5,
        floor_data: [],
      };
      this.area_list = {
        car_list: [""],
        company_list: [""],
      };

      this.e1 = 1;

      this.area_par_new = {
        country_area: "",
        floor_min_count: 0,
        floor_count: 20,
        real_name: "",
        id: "",
        user_pass: "",
        manager_pass: "",
        Elevation: 0.5,
        floor_data: [],
      };

      this.e2 = 1;

      try {
        this.$refs.refFile.files[0] = null;
      } catch (error) {
        console.log("no file");
      }

      this.isupload = false;

      this.area_list.car_list = [];
      this.area_list.company_list = [];
      this.importCsv();
      this.dialog_set_area = false;
    },

    get_select_gui(para) {
      if (this.select_gui == "1") {
        return para.company;
      } else if (this.select_gui == "3") {
        return para.sigfoxid;
      } else {
        return para.sigfoxid;
      }
    },

    
    get_rent_color(rent_company) {
      

      /*for (let a = 0; a < this.desserts_user_rent_company_list.length; a++) {
        if (
          rent_company ===
          this.desserts_user_rent_company_list[a].user_rent_company
        ) {
          return this.desserts_user_rent_company_list[a]
            .user_rent_company_color;
        }
      }
      return "blue";*/
      console.log(rent_company)

      if (rent_company == "アクティオ") {
        return "#F44336";
      } else if (rent_company == "朝日機材") {
        return "#33691E";
      } else if (rent_company == "西尾レントオール") {
        return "#1A237E";
      } else {
        return "#000000";
      }
    },

    get_rent_size(rent_company) {
      if (rent_company != "" && rent_company != " ") {
        return 5;
      } else {
        return 0;
      }
    },

    reload_now() {
      window.location.reload();
    },

    isMobile() {
      //console.log("1111");
      var ua = navigator.userAgent;
      //console.log(ua)
      if (
        !(
          ua.indexOf("iPhone") > 0 ||
          ua.indexOf("iPad") > 0 ||
          ua.indexOf("Android") > 0 ||
          ua.indexOf("Mobile") > 0
        )
      ) {
        //return false
        this.mobile_check = false;
      } else {
        this.mobile_check = true;
        //return true
      }
    },

  },

  mounted() {
      this.getData();
      console.log('test')
      //this.initialize ();
      //this.auto_refresh_control(true);
      
    
    
  },
};
</script>

